import { Icon } from '@chakra-ui/react'

type Props = {
    fill?: string
}

export const IconDeclined = ({ fill }: Props): JSX.Element => {
    return (
        <Icon viewBox={`0 0 16 16`} w={`16px`} h={`16px`} fill="none">
            <path
                d="M16 8C16 12.4187 12.4187 16 8 16C3.58125 16 0 12.4187 0 8C0 3.58125 3.58125 0 8 0C12.4187 0 16 3.58125 16 8ZM2.70937 3.41563C1.64437 4.64375 1 6.24687 1 8C1 11.8656 4.13438 15 8 15C9.75313 15 11.3563 14.3562 12.5844 13.2906L2.70937 3.41563ZM15 8C15 4.13438 11.8656 1 8 1C6.24687 1 4.64375 1.64437 3.41563 2.70937L13.2906 12.5844C14.3562 11.3563 15 9.75313 15 7.97188V8Z"
                fill={fill ? fill : '#FF4747'}
            />
        </Icon>
    )
}
